import React, { Dispatch, SetStateAction } from 'react';
import { Platform } from '../../../web/react-native';
import styled from '../../../components/styled';

import { RegularText, TextField } from '../../../components';

interface UpdatePercentageActionFieldProps {
  percentage: string;
  onChange: Dispatch<SetStateAction<string>>;
  errors: string[];
}

const UpdatePercentageActionField = ({
  percentage,
  onChange,
  errors,
}: UpdatePercentageActionFieldProps) => {
  const hasErrors = errors.length > 0;
  return (
    <>
      <Description>Percentage Completed</Description>
      <View>
        <PercentageInput
          error={hasErrors}
          autoFocus
          right
          onChangeText={onChange}
          placeholder="0"
          scrollEnabled={false}
          keyboardType={Platform.OS === 'android' ? 'numeric' : 'number-pad'}
          defaultValue={percentage + ''}
        />
        <Text style={{ marginLeft: 5 }}>%</Text>
      </View>
      {hasErrors && <ErrorText>{errors[0]}</ErrorText>}
    </>
  );
};

export default UpdatePercentageActionField;

const Description = styled.Text`
  margin-top: 10px;
  font-weight: 500;
  margin-bottom: 7px;
`;

const View = styled.View`
  flex-direction: row;
  align-items: center;
`;

const PercentageInput = styled(TextField)`
  align-items: flex-end;
  max-height: 55px;
`;

const Text = styled(RegularText)`
  margin-right: 5px;
`;

const ErrorText = styled.Text`
  color: red;
  margin-top: 5px;
`;
